<template>
<div>
<template v-if="show">
    <div class="container">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Assign Shift </h1>

            </div>
            <div class="shift-mangement-top-box mb-3">
            <form @submit.prevent="assignShift">
                <div class="row">
                    <div class="col-md-12">
                       <div class="form-group">
                            <label class="label block-label">Shifts<em class="required">*</em> </label>
                            <select  class="form-control shifts selectpicker"  id="shifts" name="shift" v-model="form.shift"  >
                              <option value="">Select shift</option>
                                <option v-for="shift in shifts" v-bind:value="shift.id" v-bind:key="shift.id">{{ shift.name }}</option>
                            </select>
                        </div>
                    </div>
                     <div class="col-md-12">
                       <div class="form-group">
                            <label class="label block-label">Teams </label>
                            <select  data-live-search="true" class="form-control selectpicker" multiple id="teams" name="teams" v-model="form.teams" >
                                <option v-for="team in teams" v-bind:value="team.id" v-bind:key="team.id">{{ team.name }}</option>
                            </select>
                        </div>
                    </div>
                     <div class="col-md-12">
                       <div class="form-group">
                            <label class="label block-label">Department </label>
                            <select  data-live-search="true" class="form-control selectpicker" multiple  id="department" name="status" v-model="form.departments">
                                <option v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id">{{ department.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-12">
                       <div class="form-group">
                            <label class="label block-label">Individual </label>
                            <select  data-live-search="true" class="form-control" multiple id="individuals" name="individuals" v-model="form.individuals">
                               
                                 <option v-for="(individual,index) in individuals" v-bind:value="individual.id" v-if="IndividualCondition(individual.department_id,index,individual.id)" v-bind:key="individual.id">{{ individual.name }}</option>
                            </select>
                        </div>
                    </div>
                     <div class="col-md-12">
                             <button class="btn btn-primary active"> Done </button>
                     </div>
                </div>
             </form>
            </div>
           
        </div>
    </template>

  <template v-else>
        <preLoader></preLoader>
    </template>
    </div>
</template>
 <script>
    export default {
        data(){
            return{
              form:new Form({
                  shift:'',
                  teams:[],
                  departments:[],
                  individuals:[]
              }),
              shifts:[],
              teams:[],
              departments:[],
              individuals:[],
              userTeams:[],
              show:false,
            }
        },
        methods:{
            fetchdetail(id){
                 this.$Progress.start();
                 let self=this;
                this.form.get('api/getShiftDetail/'+id)
                .then(res => {
                        self.form.individuals=res.data.individual;
                        self.form.departments=res.data.department;
                        self.form.teams=res.data.team;
                        self.$Progress.finish();
                        self.showToastBox('success','Detail Fetched successfully.');
                        setTimeout(function(){
                             $("#individuals").selectpicker('refresh'); 
                         $(".selectpicker").selectpicker('refresh')
                        },0)
                    

                })
                .catch(err => {
                    self.$Progress.fail();
                    self.showAlertBox('error','Soemthing went wrong!');
                });
            },
            IndividualCondition(departmentId,index,userId){
                     if(index==individuals.length-1){
                        setTimeout(function(){  $("#individuals").selectpicker('refresh'); }, 0);
                     }
                     var userTeams=(this.userTeams[userId]==undefined)?[]:this.userTeams[userId];
                    //  const intersection = this.teams.filter(element => userTeams.includes(element));
                    var common = this.form.teams.filter(x => userTeams.indexOf(x) !== -1);
                    if(common.length>0)
                     console.log(common);
                  if($.inArray(departmentId, this.form.departments)!== -1  || common.length>0 ){
                    
                     return false;
                  }
                     return true;
            },
            assignShift(){
                 let self=this;
                 if(this.form.shift !== '' && this.form.teams.length==0 && this.form.departments.length==0 && this.form.individuals.length==0){
                    self.showAlertBox('error','Please select atleast one field!');
                    return false;
                  }
                   this.$Progress.start();
                this.form.post('api/assignShift')
                .then(res => {
                    if(res.data.status){
                        self.$Progress.finish();
                        self.showToastBox('success','Shift assigned successfully.');
                       this.$router.push('/newShifts');
                    }else{
                        self.$Progress.fail();
                        self.showAlertBox('error','Some problem in your form data');
                    }
                })
                .catch(err => {
                    self.$Progress.fail();
                    self.showAlertBox('error','Soemthing went wrong!');
                });
            },
            getList(){
                 this.$Progress.start();
                 let self=this;
                axios.get('api/getListsForShiftAssignment')
                .then(res => {
                        self.show=true;
                     
            
               
                        self.$Progress.finish();
                        setTimeout(function(){  
                                self.shifts=res.data.NewShifts;
                                self.teams=res.data.team;
                                self.departments=res.data.Departments;
                                self.individuals=res.data.User;
                                self.userTeams=res.data.teamUsers;
                            $('#shifts').on('change',function(){
                                self.fetchdetail($(this).val())
                            })
                            $(".selectpicker").selectpicker('refresh'); 
                           $("#individuals").selectpicker('refresh'); 
                           }, 0);
                })
                .catch(err => {
                    self.$Progress.fail();
                    self.showAlertBox('error','Something went wrong!');
                    console.log(err)
                });
            }
        },
        mounted(){
            let self=this;
              this.getList();
              $(document).ready(function(){
                
                    $(".selectpicker").selectpicker();
                    $("#individuals").selectpicker();
              })
        }
    }
</script>